import { StateKey } from 'common/utils/flipState'
import { ReviewEvaluationState } from 'common/types/entities/review'
import { CommonState } from 'common/types'
import { fetchEvaluations } from 'common/services/review'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'

const initialState: ReviewEvaluationState = {
  productReviewEvaluationVOs: [],
  reviewTopicVOs: [],
  cacheParam: null,
}

const FETCH = 'review/evaluation/FETCH'

export const fetchReviewEvaluations = (
  curState: StateKey,
  categoryId: string,
  naverPaySellerNo: string,
  originProductNo: string,
) => async (dispatch, getState: () => CommonState) => {
  const cacheParam = createCacheParam(FETCH, 'fetchReviewEvaluations', {
    curState,
    categoryId,
    naverPaySellerNo,
    originProductNo,
  })

  if (isCacheHit(getState().reviewEvaluation[curState], cacheParam)) {
    return
  }

  const reviewEvaluation = await fetchEvaluations({
    originProductNo,
    leafCategoryId: categoryId,
    merchantNo: naverPaySellerNo,
  })
  if (reviewEvaluation) {
    const { productReviewEvaluationVOs, reviewTopicVOs } = reviewEvaluation
    return dispatch({
      curState,
      cacheParam,
      productReviewEvaluationVOs,
      reviewTopicVOs,
      type: FETCH,
    })
  }
  return dispatch({
    curState,
    ...initialState,
    cacheParam,
    type: FETCH,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        productReviewEvaluationVOs: action.productReviewEvaluationVOs,
        reviewTopicVOs: action.reviewTopicVOs,
        cacheParam: action.cacheParam,
      }
    default:
      return state
  }
}

export default reducer
